<div uppViewMode>
    <ng-container *ngIf="viewMode === 'GRID'">
        <ion-card uppTouch [color]="color" (click)="OnSelect()" (mousedown)="OnPressed(true)" (mouseup)="OnPressed(false)" (onTouchStart)="OnPressed(true)" (onTouchLeave)="OnPressed(false)">
            <ng-container *ngIf="icon === null">
                <div *ngIf="wait === true" class="shape" [ngClass]="shape">
                    <ion-spinner name="lines"></ion-spinner>
                </div>
                <div *ngIf="wait !== true" class="shape" [ngClass]="shape">
                    <upp-image [src]="card || avatar"></upp-image>
                </div>
            </ng-container>
            <ng-container *ngIf="icon !== null">
                <div class="icon-box">
                    <ion-icon [color]="color" [name]="icon" [ngClass]="{ 'foot': foot !== null }"></ion-icon>
                    <ion-label [color]="color" *ngIf="foot">{{foot}}</ion-label>
                </div>
            </ng-container>
            <ion-card-header>
                <ion-card-title>{{title}}</ion-card-title>
            </ion-card-header>
        </ion-card>
        <ng-content select="upp-thumb-top-left"></ng-content>
        <ng-content select="upp-thumb-top-right"></ng-content>
        <ng-content select="upp-thumb-bottom"></ng-content>    
    </ng-container>
    <ng-container *ngIf="viewMode === 'LIST'">
        <ion-item uppTouch (click)="OnSelect()" (mousedown)="OnPressed(true)" (mouseup)="OnPressed(false)" (onTouchStart)="OnPressed(true)" (onTouchLeave)="OnPressed(false)">
            <upp-image slot="start" [src]="card || avatar"></upp-image>
            <ion-label>
                {{title}}
                <span *ngIf="detail" class="small"><br/>{{detail}}</span>
            </ion-label>
            <ng-content slot="end" select="upp-thumb-top-left"></ng-content>
            <ng-content slot="end" select="upp-thumb-top-right"></ng-content>
        </ion-item>
    </ng-container>    
</div>
